import React, { FC } from 'react';

import { GoogleIcon } from '../../assets/icons/index';
import { AppFormattedMessage } from '../app-formatted-message/index';

interface GoogleAuthButtonProps {
  onClick?: () => void;
}

const GoogleAuthButton: FC<GoogleAuthButtonProps> = ({ onClick }) => {
  return (
    <div
      className="flex cursor-pointer select-none items-center justify-center gap-2.5 rounded bg-[#F2F2F2] py-3"
      onClick={onClick}
    >
      <GoogleIcon />
      <div className="font-roboto text-sm font-[550] text-[#1F1F1F]">
        <AppFormattedMessage id="CONTINUE_WITH_GOOGLE" />
      </div>
    </div>
  );
};

export default GoogleAuthButton;
